import { render, staticRenderFns } from "./Pods.vue?vue&type=template&id=64509980&"
import script from "./Pods.vue?vue&type=script&lang=js&"
export * from "./Pods.vue?vue&type=script&lang=js&"
import style0 from "./Pods.vue?vue&type=style&index=0&id=64509980&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports